module.exports = __webpack_public_path__ + "img/order-count-icon.ef86b250.png";